<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<div class="markdown-renderer-container">
  <!-- Loading State -->
  <div *ngIf="loading" class="loading-state">
    <div class="loading-spinner"></div>
    <span class="loading-text">Loading documentation...</span>
  </div>

  <!-- Error State -->
  <div *ngIf="error && !loading" class="error-state">
    <div class="error-icon">⚠️</div>
    <div class="error-content">
      <h3>Failed to Load Documentation</h3>
      <p>{{ error.message }}</p>
      <small *ngIf="error.filePath">File: {{ error.filePath }}</small>
    </div>
  </div>

  <!-- Content State -->
  <div *ngIf="!loading && !error" class="markdown-content-wrapper">
    <!-- Markdown Content -->
    <div #markdownContainer
         *ngIf="content && content.trim().length > 0"
         class="markdown-content"
         [innerHTML]="renderedHtml">
    </div>

    <!-- Empty State -->
    <div *ngIf="!content || content.trim().length === 0" class="empty-state">
      <div class="empty-icon">📄</div>
      <p>No content to display</p>
    </div>
  </div>
</div>
